// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 viewBox=%270 0 16 16%27%3e%3cpath d=%27M11.5 1.5a.5.5 0 0 1 0 .707L6.707 7.5H15.5a.5.5 0 0 1 0 1H6.707l4.793 4.793a.5.5 0 0 1-.707.707l-5.5-5.5a.5.5 0 0 1 0-.707l5.5-5.5a.5.5 0 0 1 .707 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 viewBox=%270 0 16 16%27%3e%3cpath d=%27M4.5 1.5a.5.5 0 0 0 0 .707L9.293 7.5H.5a.5.5 0 0 0 0 1h8.793L4.5 13.293a.5.5 0 1 0 .707.707l5.5-5.5a.5.5 0 0 0 0-.707l-5.5-5.5a.5.5 0 0 0-.707 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bootstrap Carousel CSS */
.carousel {
  position: relative;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}
.carousel-item-next,
.carousel-item-prev,
.carousel-item.active {
  display: block;
}

.carousel-item-next,
.carousel-item-prev {
  position: absolute;
  top: 0;
  width: 100%;
  transition: transform 0.6s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-item-next,
  .carousel-item-prev {
    transition: none;
  }
}
.carousel-item-next {
  transform: translateX(100%);
}

.carousel-item-prev {
  transform: translateX(-100%);
}

.carousel-item-next.carousel-item-left,
.carousel-item-prev.carousel-item-right {
  transform: translateX(0);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}

.carousel-fade .carousel-item-next,
.carousel-fade .carousel-item-prev,
.carousel-fade .carousel-item.active {
  left: 0;
  transform: translateX(0);
}

.carousel-fade .carousel-item-next,
.carousel-fade .carousel-item-prev {
  opacity: 0;
  transition: opacity 0.6s ease-in-out;
}

.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right,
.carousel-fade .carousel-item.active {
  opacity: 1;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-fade .carousel-item-next,
  .carousel-fade .carousel-item-prev {
    transition: none;
  }
}
.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  color: #fff;
  text-align: center;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover,
.carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: no-repeat 50%/100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 10px;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}

.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/carousel.scss"],"names":[],"mappings":"AAAA,2BAAA;AACA;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EAEA,2BAAA;EACA,sCAAA;AACF;;AAEA;EACE;IACE,gBAAA;EACF;AACF;AAEA;;;EAGE,cAAA;AAAF;;AAGA;;EAEE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,sCAAA;AAAF;;AAGA;EACE;;IAEE,gBAAA;EAAF;AACF;AAGA;EACE,2BAAA;AADF;;AAIA;EACE,4BAAA;AADF;;AAIA;;EAEE,wBAAA;AADF;;AAIA;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AADF;;AAIA;;;EAGE,OAAA;EACA,wBAAA;AADF;;AAIA;;EAEE,UAAA;EACA,oCAAA;AADF;;AAIA;;;EAGE,UAAA;AADF;;AAIA;EACE;;IAEE,gBAAA;EADF;AACF;AAIA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,8BAAA;AAFF;;AAKA;EACE;;IAEE,gBAAA;EAFF;AACF;AAKA;;;;EAIE,WAAA;EACA,qBAAA;EACA,UAAA;EACA,YAAA;AAHF;;AAMA;EACE,OAAA;AAHF;;AAMA;EACE,QAAA;AAHF;;AAMA;;EAEE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;AAHF;;AAMA;EACE,yDAAA;AAHF;;AAMA;EACE,yDAAA;AAHF;;AAMA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,uBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,4BAAA;EACA,SAAA;EACA,YAAA;EACA,6BAAA;AAHF;;AAMA;EACE;IACE,gBAAA;EAHF;AACF;AAMA;EACE,UAAA;AAJF;;AAOA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;AAJF","sourcesContent":["/* Bootstrap Carousel CSS */\r\n.carousel {\r\n  position: relative;\r\n}\r\n\r\n.carousel-inner {\r\n  position: relative;\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.carousel-item {\r\n  position: relative;\r\n  display: none;\r\n  float: left;\r\n  width: 100%;\r\n  margin-right: -100%;\r\n  -webkit-backface-visibility: hidden;\r\n  backface-visibility: hidden;\r\n  transition: transform 0.6s ease-in-out;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .carousel-item {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.carousel-item-next,\r\n.carousel-item-prev,\r\n.carousel-item.active {\r\n  display: block;\r\n}\r\n\r\n.carousel-item-next,\r\n.carousel-item-prev {\r\n  position: absolute;\r\n  top: 0;\r\n  width: 100%;\r\n  transition: transform 0.6s ease-in-out;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .carousel-item-next,\r\n  .carousel-item-prev {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.carousel-item-next {\r\n  transform: translateX(100%);\r\n}\r\n\r\n.carousel-item-prev {\r\n  transform: translateX(-100%);\r\n}\r\n\r\n.carousel-item-next.carousel-item-left,\r\n.carousel-item-prev.carousel-item-right {\r\n  transform: translateX(0);\r\n}\r\n\r\n.carousel-fade .carousel-item {\r\n  opacity: 0;\r\n  transition-property: opacity;\r\n  transform: none;\r\n}\r\n\r\n.carousel-fade .carousel-item-next,\r\n.carousel-fade .carousel-item-prev,\r\n.carousel-fade .carousel-item.active {\r\n  left: 0;\r\n  transform: translateX(0);\r\n}\r\n\r\n.carousel-fade .carousel-item-next,\r\n.carousel-fade .carousel-item-prev {\r\n  opacity: 0;\r\n  transition: opacity 0.6s ease-in-out;\r\n}\r\n\r\n.carousel-fade .carousel-item-next.carousel-item-left,\r\n.carousel-fade .carousel-item-prev.carousel-item-right,\r\n.carousel-fade .carousel-item.active {\r\n  opacity: 1;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .carousel-fade .carousel-item-next,\r\n  .carousel-fade .carousel-item-prev {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.carousel-control-prev,\r\n.carousel-control-next {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  z-index: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 15%;\r\n  color: #fff;\r\n  text-align: center;\r\n  opacity: 0.5;\r\n  transition: opacity 0.15s ease;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .carousel-control-prev,\r\n  .carousel-control-next {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.carousel-control-prev:hover,\r\n.carousel-control-prev:focus,\r\n.carousel-control-next:hover,\r\n.carousel-control-next:focus {\r\n  color: #fff;\r\n  text-decoration: none;\r\n  outline: 0;\r\n  opacity: 0.9;\r\n}\r\n\r\n.carousel-control-prev {\r\n  left: 0;\r\n}\r\n\r\n.carousel-control-next {\r\n  right: 0;\r\n}\r\n\r\n.carousel-control-prev-icon,\r\n.carousel-control-next-icon {\r\n  display: inline-block;\r\n  width: 20px;\r\n  height: 20px;\r\n  background: no-repeat 50% / 100% 100%;\r\n}\r\n\r\n.carousel-control-prev-icon {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 16 16'%3e%3cpath d='M11.5 1.5a.5.5 0 0 1 0 .707L6.707 7.5H15.5a.5.5 0 0 1 0 1H6.707l4.793 4.793a.5.5 0 0 1-.707.707l-5.5-5.5a.5.5 0 0 1 0-.707l5.5-5.5a.5.5 0 0 1 .707 0z'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.carousel-control-next-icon {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 16 16'%3e%3cpath d='M4.5 1.5a.5.5 0 0 0 0 .707L9.293 7.5H.5a.5.5 0 0 0 0 1h8.793L4.5 13.293a.5.5 0 1 0 .707.707l5.5-5.5a.5.5 0 0 0 0-.707l-5.5-5.5a.5.5 0 0 0-.707 0z'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.carousel-indicators {\r\n  position: absolute;\r\n  right: 0;\r\n  bottom: 10px;\r\n  left: 0;\r\n  z-index: 2;\r\n  display: flex;\r\n  justify-content: center;\r\n  padding-left: 0;\r\n  margin-right: 15%;\r\n  margin-left: 15%;\r\n  list-style: none;\r\n}\r\n\r\n.carousel-indicators [data-bs-target] {\r\n  box-sizing: content-box;\r\n  flex: 0 1 auto;\r\n  width: 30px;\r\n  height: 3px;\r\n  margin-right: 3px;\r\n  margin-left: 3px;\r\n  text-indent: -999px;\r\n  cursor: pointer;\r\n  background-color: #fff;\r\n  background-clip: padding-box;\r\n  border: 0;\r\n  opacity: 0.5;\r\n  transition: opacity 0.6s ease;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .carousel-indicators [data-bs-target] {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.carousel-indicators .active {\r\n  opacity: 1;\r\n}\r\n\r\n.carousel-caption {\r\n  position: absolute;\r\n  right: 15%;\r\n  bottom: 20px;\r\n  left: 15%;\r\n  z-index: 10;\r\n  padding-top: 20px;\r\n  padding-bottom: 20px;\r\n  color: #fff;\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
